import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteVehicleBrandSchema = z.object({
  id: z.number(),
});

export const getVehicleBrandsRequestSchema = z.object({
  sort: zodSortField(["name"]),
});

export const addVehicleBrandSchema = z.object({
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(50, "Maximum de caractères atteint"),
});

export const editVehicleBrandSchema = z.object({
  id: z.number().optional(),
  name: z
    .string()
    .min(1, "Le nom est requis")
    .max(50, "Maximum de caractères atteint"),
  isActive: z.boolean().default(true),
});
